import { addDays as t } from "./addDays.js";
function s(a, r) {
  return t(a, -r);
}
export {
  s as default,
  s as subDays
};
//# sourceMappingURL=subDays.js.map
